import { List as ImmutableList, Record } from 'immutable';
// import type { RecordOf } from 'immutable';

/*
 * Core types for AI CHAT
 */

/*
 AiRoleEnum
 */
export const AiRoleEnum = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
};

/*
 AiChatTurn
 */
// export const AiChatTurn = {
//  role: string;
//  message: string;
// };
/*
 AiChatHistory
 */
// export type AiChatHistory = AiChatTurn[];

/*
 AiPromptRequest
 */
// export type AiPromptRequest = {
//   prompt: string;
//   context: any; // This is an object that will be converted to JSON
//   history: AiChatHistory;
// };

export const mkAiPromptRequest = (props) => ({
  prompt: props.prompt || '',
  context: props.context || {},
  history: props.history || [],
  options: {
    model: 'gpt-4o-mini',
  },
  ...props,
});

/*
export interface AiStoreState {
  isLoading: boolean;
  history: object;
}
 */

// export type AiStoreType = RecordOf<AiStoreState>;

// Create a Record factory with default values
export const mkAiConversationsStore = Record({
  isLoading: false,
  history: ImmutableList(), // Initially empty
});

export const mkErrorChatTurn = (message) => ({ role: AiRoleEnum.ASSISTANT, message });
export const mkChatTurn = (role, message) => ({ role, message });
